// CSV building for the call exports.
//
// The exports previously joined fields with a bare `,`, so any field containing a comma - a job
// name, a campaign, a template, or a call key inside a URL - silently shifted every later column
// on that row. Quoting is only applied where it is needed, so an export of ordinary data is
// byte-identical to what it was before.

// Quote a field only when it has to be: comma, double-quote, CR or LF. Inner quotes are doubled,
// per RFC 4180, which is what Excel and Google Sheets expect.
export const escapeCsvField = (value) => {
  const s = value === undefined || value === null ? '' : String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const toCsv = (headers, rows) =>
  [headers, ...rows].map(row => row.map(escapeCsvField).join(',')).join('\n');

// Absolute link to a call's detail page, for a spreadsheet cell. Same route the call tables open.
// Excel and Sheets auto-linkify a bare URL; an =HYPERLINK() formula would not survive being read
// by anything else.
export const callDetailUrl = (item) => {
  const key = item?.key || item?.filename;
  if (!key) return '';
  return `${window.location.origin}/dashboard/${key}`;
};
